export const SIDEBAR_WIDTH = 280;
